// removed by extract-text-webpack-plugin
module.exports = {"name":"uDeZV","fy":"_2pLwj","status":"_3tBnZ","tooltip":"ImTvu","lastUpdated":"_3Mw0Q","view":"_8topv","header":"_3ZEfB","description":"_1yXRM","formurl":"_38hzg","timestamp":"M8Wv9","partner":"_3Gkww"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerPlans/columns.scss
// module id = 83
// module chunks = 0